import { newTracker } from '@snowplow/browser-tracker';

export const TRACKER_NAME = 'cs-features';

let isInitialised = false;

/**
 * Deliberately absent from `.env.example`: `dotenv-safe` runs with
 * `allowEmptyValues: false`, so adding it there would stop the server booting
 * until every developer added it to their own `.env`. Tracking no-ops instead.
 */
function getCollectorDomain(): string | undefined {
  return window.configs?.SNOWPLOW_COLLECTOR_DOMAIN || undefined;
}

export function initialiseSnowplowTracker(): boolean {
  const collectorDomain = getCollectorDomain();

  if (!collectorDomain) {
    return false;
  }

  if (isInitialised) {
    return true;
  }

  newTracker(TRACKER_NAME, collectorDomain, {
    appId: 'admin-portal',
    // Matches the backend emitters (svc-auth, svc-order); the warehouse queries
    // read the unencoded payload.
    encodeBase64: false,
    // Admin is served from a single host, so skip the root-domain probe, which
    // works by writing throwaway cookies that are expected to fail.
    discoverRootDomain: false,
  });

  isInitialised = true;
  return true;
}
